import type { Props } from './Svg'
import { Svg } from './Svg'

export function DocumentIcon(props: Props) {
  return (
    <Svg strokeWidth="2" {...props}>
      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
      <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2ZM9 9h1M9 13h6M9 17h6" />
    </Svg>
  )
}
